import { getImageDataFromImg } from "./utils.js";
import { tracingImageDataToSVG } from "./png_tracer.js";
import { pixelBinarize } from "./webgl_processing.js";
import potrace from "potrace";

export const getSVGFromRasterTracing = async ({ image_el, trace_options }) => {
  const trace_svg_el = tracingImageDataToSVG(
    getImageDataFromImg(image_el, trace_options?.smoothPercentage, trace_options?.binarize_threshold),
    trace_options
  );
  return Promise.resolve(trace_svg_el);
};

export const getSVGFromRasterTracing2 = async ({ image_el, trace_options }) => {
  const { color, is_alpha_binarize, threshold, ...opt } = trace_options;
  const binarized_base64 = await pixelBinarize({
    image: image_el,
    color,
    is_alpha_binarize,
    threshold,
  });
  const trace_option = {
    background: potrace.Potrace.COLOR_TRANSPARENT,
    color: potrace.Potrace.COLOR_TRANSPARENT,
    ...opt,
  };

  return new Promise((resolve, reject) => {
    potrace.trace(binarized_base64, trace_option, (e, svg) => {
      if (e) {
        reject(e);
      } else {
        resolve(svg);
      }
    });
  });
};
